<!-- 财务 -> 账户流水 -->
<template>
    <div class="templete">
        <div class="search_box search_box_f clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <!-- <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.search.customer_id = res;}"></select-down-customer> -->
            <el-select class="search_select search_inputBox" v-model="params.search.customer_name" placeholder="客户名称" filterable @visible-change="getSelectList('billCustomer')">
                <el-option v-for="list in selectMap.billCustomer" :key="list.name" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.search.account_id" placeholder="我方账户名称" filterable @visible-change="getSelectList('account')">
                <el-option v-for="list in selectMap.account" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <el-input class="search_input search_inputBox" v-model="params.search.account_id" placeholder="我方账户名称"></el-input> -->
            <el-input class="search_input search_inputBox" v-model="params.search.course_title" placeholder="科目名称"></el-input>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <!-- <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible;scene='finance.receivables';isGlobal=false;filter=copy_filter;"></div> -->
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList clearfix">
            <!-- <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',finance-account-manage-edit,')!=-1" @click="addFlow">添加流水</el-button> -->
            <!-- <el-button class="funcPublicBtn">修改</el-button> -->
            <el-button class="funcPublicBtn" v-if="module.indexOf(',finance-account-manage-edit,')!=-1" @click="batchDel">批量删除</el-button>
        </div>
        <div class="tableBox">
            <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="totalCal">
            <div class="totalName">合计：</div>
            <div class="totalNumber">总收入:{{totalObj.in_amount}}</div>
            <div class="totalNumber">总支出:{{totalObj.out_amount}}</div>
            <div class="totalNumber">账户余额:{{totalObj.account_balance}}</div>
        </div>
        <!-- 新增流水 dialog START -->
        <el-dialog v-dialog-drag title="添加流水" :visible.sync="addDialogVisible" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="销售单号：">
                        <el-input v-model="add_params.order_sn" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" disabled type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：">
                        <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户名称：">
                        <el-input v-model="add_params.customer_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="add_params.bill_type" placeholder="" >
                            <el-option :value="0"  label="收入"></el-option>
                            <el-option :value="1"  label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易方式：">
                        <el-select v-model="add_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="add_params.course_title" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="交易RMB金额：">
                        <el-input v-model="add_params.amount" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderSheet">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增流水 dialog END -->
    </div>
</template>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    import selectDownCustomer from '../../components/selectDownCustomer.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                start_time:"",
                end_time:new Date(),
                params:{
                    search:{
                        start_time:"",
                        end_time:"",
                        account_id:"",
                        course_title:"",
                        customer_name:"",
                    },
                    page:1,
                    per_page:50
                },
                last_page:1,
                total:0,
                selectRow:[],
                selectMap:{
                    customer:[],
                    account:[],
                    paymentType:[],
                    billCustomer:[]
                },
                addDialogVisible:false,
                trading_time:"",
                add_params : {
                    order_id : "",
                    bill_type : "",
                    amount : "",
                    account_id : "",
                    customer_id : "",
                    trading_time :"",
                    trading_mode_id : "",
                    course_title : "进销货款",
                    remark : ""
                },
                list:[],
                tableCol:[	
                    {colName:"交易日期",colKey:"trading_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"科目名称",colKey:"course_title",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"我方账户名称",colKey:"account_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"收入",colKey:"in_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"支出",colKey:"out_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"账户余额",colKey:"account_balance",colWidth:140,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"单据编号",colKey:"order_sn",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"经办人",colKey:"operator_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"创建日期",colKey:"create_time",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                totalObj:{}
            }
        },
        created(){
            this.getSelectList("account")
            this.getSelectList("customer")
            this.getList()
        },
        methods:{
            excelExport(){
                this.$exportExecl("/erp/finance.bill.export","账户流水",this.params)
            },
            //添加流水
            addOrderSheet(){
                this.$confirm('是否确认添加流水?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_params.trading_time=this.formatTimeZero(this.trading_time)
                    this.postFunc("/erp/finance.inout",this.add_params,()=>{
                        this.tip("添加成功","success")
                        this.addDialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            addFlow(){
                if(this.selectRow.length>1||this.selectRow.length<1){
                    this.tip("请选择一条数据","warning")
                }else{
                    this.addDialogVisible = true;
                    this.add_params.order_id=this.selectRow[0].id;
                    this.add_params.order_sn=this.selectRow[0].order_sn;
                    this.add_params.customer_id=this.selectRow[0].customer_id;
                    this.add_params.bill_type=0;
                    this.trading_time=this.selectRow[0].trading_time;
                    this.add_params.payment_type_id=this.selectRow[0].payment_type_id;
                    this.add_params.account_id=this.selectRow[0].account_id;
                    this.add_params.course_title='进销货款';
                }
            },
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    this.$confirm('是否删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        this.selectRow.forEach(item=>{
                            arr.push(item.id)
                        })
                        let ids = arr.toString();
                        this.postFuncLoading("/erp/bill.delete",{ids:ids},()=>{
                            this.tip('删除成功','success');
                            this.getList()
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            reset(){
                this.start_time="",
                this.end_time=new Date(),
                this.params={search:{start_time:"",end_time:"",account_name:"",course_title:"",customer_name:""},page:1,per_page:50}
                // this.$refs['selectdowncustomer'].clearData()
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.start_time=this.formatTimeZero(this.start_time)
                this.params.search.end_time=this.formatTimeZero(this.end_time)
                this.tableLoading = true;
                this.postFunc("/erp/finance.bill.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.totalObj=res.data.data.statistics;
                    this.totalObj.in_amount=this.keepPrice(res.data.data.statistics.in_amount);
                    this.totalObj.out_amount=this.keepPrice(res.data.data.statistics.out_amount);
                    this.totalObj.account_balance=this.keepPrice(res.data.data.statistics.account_balance);
                    this.list=res.data.data.list;
                    this.list.forEach((item,index)=>{
                        if(item.trading_time!=0){
                            this.list[index].trading_time = this.formatTime(item.trading_time+"000")
                        }else{
                            this.list[index].trading_time = "";
                        }
                        if(item.create_time!=0){
                            this.list[index].create_time = this.formatTimeSecond(item.create_time+"000")
                        }else{
                            this.list[index].create_time = "";
                        }
                        if(Number(item.in_amount)==0){
                            this.list[index].in_amount = "";
                        }else{
                            this.list[index].baseColor = "#FF0000";
                        }
                        if(Number(item.out_amount)==0){
                            this.list[index].out_amount = "";
                        }else{
                            this.list[index].baseColor = "green";
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(){
                
            },
            getRow(row){
                this.selectRow=row;
            },
        },
        components:{
            tabletem,
            pagination,
            selectDownCustomer
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "addDialogVisible":function(val){
                if(!val){
                    this.add_params=this.resetJson(this.add_params)
                    this.add_params.course_title="进销货款";
                }
            },
        }
    }
</script>
<style scoped lang="scss">
</style>
